<template lang="pug">
.details
  .card
    header.card-header
      p.card-header-title {{row.title}}
      .delete.is-pulled-right(@click="$emit('close')")
    .card-image(v-if="row.image")
      figure.image.is-4by3
        img(:src="row.image")
    .card-content
      nav.breadcrumb
        ul
          li(v-for="ancestor in getAncestry()")
            a {{ancestor.title}}
          li.is-active
            a {{row.title}}
      p(v-if="row.description") {{row.description}}
      .content
        ContentGoals(:row="row" :goal="target.tree")
        //- GoalTree(:row="row" :goal="target.tree")
         
        
          
</template>

<script>
import _ from 'lodash'

import GoalTree from './GoalTree.vue'
import ContentGoals from './ContentGoals.vue'

export default {
  props: ['row', 'target'],
  components: {
    GoalTree, ContentGoals
  },
  methods: {
    getAncestry() {
      let as = []
      let i = this.row.parent // skip me
      while (i) {
        as.push(i)
        i = i.parent
      }
      return _.reverse(as)
    }
    
  }
}
</script>

<style scoped>
.details {
  margin: 24px;
}
.details .card {
  min-height: 400px;
  overflow: hidden;
}
.details .card .delete {
  margin: 8px;
}
</style>
